import React from 'react';

export default function NotificationCircle() {
  return (
    <svg
      width='32'
      height='32'
      viewBox='0 0 32 32'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z'
        fill='#27272A'
      />
      <g clipPath='url(#clip0_417_8123)'>
        <path
          d='M14.8674 21.9999C14.9789 22.2029 15.143 22.3721 15.3423 22.49C15.5417 22.6079 15.7691 22.6701 16.0007 22.6701C16.2323 22.6701 16.4597 22.6079 16.659 22.49C16.8584 22.3721 17.0224 22.2029 17.134 21.9999M10.6673 9.33325C9.86732 10.4666 9.33398 11.7999 9.33398 13.3333M22.6673 13.3333C22.6673 11.7999 22.134 10.4666 21.334 9.33325M12.0007 13.3333C12.0007 12.2724 12.4221 11.255 13.1722 10.5048C13.9224 9.75468 14.9398 9.33325 16.0007 9.33325C17.0615 9.33325 18.0789 9.75468 18.8291 10.5048C19.5792 11.255 20.0007 12.2724 20.0007 13.3333C20.0007 17.9999 22.0007 19.3333 22.0007 19.3333H10.0007C10.0007 19.3333 12.0007 17.9999 12.0007 13.3333Z'
          stroke='#A1A1AA'
          strokeWidth='1.25'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_417_8123'>
          <rect
            width='16'
            height='16'
            fill='white'
            transform='translate(8 8)'
          />
        </clipPath>
      </defs>
    </svg>
  );
}
